import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    const url = cfg.url || "";
    if (err.response?.status === 401 && !cfg._retry && !url.includes("/auth/refresh") && !url.includes("/auth/login")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

const ZERO = ["JPY", "KRW", "VND", "CLP", "ISK", "UGX", "XOF", "XAF"];
export const exp = (cur) => (ZERO.includes(cur) ? 0 : 2);
export function money(minor, cur = "USD") {
  const v = (minor || 0) / 10 ** exp(cur);
  try {
    return new Intl.NumberFormat(undefined, { style: "currency", currency: cur, minimumFractionDigits: exp(cur) }).format(v);
  } catch {
    return `${v.toFixed(exp(cur))} ${cur}`;
  }
}
export const today = () => new Date().toISOString().slice(0, 10);
export const toMajor = (minor, cur) => ((minor || 0) / 10 ** exp(cur)).toFixed(exp(cur));

export const CURRENCIES = ["USD", "EUR", "GBP", "CAD", "AUD", "MXN", "INR", "JPY", "CHF", "SEK", "NZD", "ZAR", "BRL", "SGD", "AED", "THB", "KRW"];

export function fmtDate(d) {
  if (!d) return "";
  const dt = new Date(d.length === 10 ? `${d}T12:00:00` : d);
  return dt.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
}
export const dateRange = (s, e) => (s ? `${fmtDate(s)}${e && e !== s ? ` – ${fmtDate(e)}` : ""}` : "Dates TBD");

export async function downloadFile(path, filename) {
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
